var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 26.2082H9.25002C8.23775 26.2082 7.23539 26.0088 6.30017 25.6214C5.36495 25.234 4.51519 24.6662 3.79941 23.9505C2.35381 22.5049 1.54169 20.5442 1.54169 18.4998C1.54169 16.4555 2.35381 14.4948 3.79941 13.0492C5.245 11.6036 7.20564 10.7915 9.25002 10.7915H13.875M23.125 10.7915H27.75C28.7623 10.7915 29.7647 10.9909 30.6999 11.3783C31.6351 11.7656 32.4848 12.3334 33.2006 13.0492C33.9164 13.765 34.4842 14.6148 34.8716 15.55C35.259 16.4852 35.4584 17.4876 35.4584 18.4998C35.4584 19.5121 35.259 20.5145 34.8716 21.4497C34.4842 22.3849 33.9164 23.2347 33.2006 23.9505C32.4848 24.6662 31.6351 25.234 30.6999 25.6214C29.7647 26.0088 28.7623 26.2082 27.75 26.2082H23.125V10.7915Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 18.5H24.6666",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink2);
export default __webpack_public_path__ + "static/media/link-2.5d9661249b1c9a3246496123559bbb7b.svg";
export { ForwardRef as ReactComponent };